<div class="bcg p-4 ">
  <div class="row">
    <!-- <div class="col-6">
      <div class="d-flex justify-content-between custom-container">
        <nav class="custom-nav">
          <ol class="breadcrumb">
            <li *ngIf="userRole === 'CLIENT'; else showAdminDashboard" class="breadcrumb-item" style="cursor: pointer;"
              [routerLink]="'/doqfy/dashboard'">Dashboard</li>
            <ng-template #showAdminDashboard>
              <li class="breadcrumb-item" style="cursor: pointer;" [routerLink]="'/doqfy/admin-dashboard'">Dashboard
              </li>
            </ng-template>
            <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">Cat-Edit</li>
          </ol>
        </nav>
      </div>
    </div> -->

     <div class="col-lg-8 col-sm-6 col-md-6">
      <div class="d-flex justify-content-between custom-container">
        <nav class="custom-nav">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" style="cursor: pointer;"  (click)="back()">Dashboard</li>
            <ng-template #showAdminDashboard>
              <li class="breadcrumb-item" style="cursor: pointer;" [routerLink]="'/doqfy/admin-dashboard'">Dashboard
              </li>
            </ng-template>
            <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">Cat-Edit</li>
          </ol>
        </nav>
      </div>
    </div>
    

    <div *ngIf="showProductDetails" class="col-lg-4 col-sm-6 col-md-6">
      <app-select-branch (OnBranchChangeData)=changeState($event)></app-select-branch>
    </div>
  </div>






  <div *ngIf="showProductDetails" class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_header_0">CAT Edit</h5>
          <p class="card-text text_p ">e-Stamp & eSign documents on the Cloud</p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
          <p-button label="Back" (click)="back()" styleClass="p-button-sm"></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3 card_style_bs_order_cat card_outLine">
    <div class="card-body" style="padding-bottom: 0;">
      <div class="title_header_0">Finish Setting Up in Five Simple Steps</div>
      <ul class="row steps_style" style="padding-left: 10px;">
        <li [ngClass]="[active_product ? 'box-item_active' : '', showProductDetails ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
          (click)="showProductDetails ? gotToCatEditScreen('product') : null">1. Select template
        </li>
        <li [ngClass]="[active_template ? 'box-item_active' : '', showEditTemplate ? 'boxOutline' : 'box-item',
        productDetailsData == undefined ? 'noclick' : '']" class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          (click)="showEditTemplate ? gotToCatEditScreen('editTemplate') : null">2. Edit
          template</li>
        <li [ngClass]="[active_eStamp ? 'box-item_active' : '', showEstampDetails ? 'boxOutline' : 'box-item',
        productDetailsData == undefined || editTemplateData == undefined ? 'noclick' : '']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
          (click)="showEstampDetails ? gotToCatEditScreen('estamp') : null">3. E-stamp details
        </li>
        <li [ngClass]="[active_eSign ? 'box-item_active' : '', showEsignDetails ? 'boxOutline' : 'box-item',
        productDetailsData == undefined || editTemplateData == undefined || estampData == undefined ? 'noclick' : '']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
          (click)="showEsignDetails ? gotToCatEditScreen('esign') : null">4. Signing details
          <span *ngIf="!esignData.toBeEsigned">(skipped)</span>
        </li>
        <li
          [ngClass]="[active_confirm ? 'box-item_active' : '', showConfirmation ? 'boxOutline' : 'box-item',
        productDetailsData == undefined || editTemplateData == undefined || estampData == undefined || esignData.party_users?.length == 0 ? 'noclick' : 'noclick']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
          (click)="showConfirmation ? gotToCatEditScreen('confirmation') : null">5. Order
          confirmation</li>
      </ul>


    </div>
  </div>
  <div *ngIf="showEstampDetails" class="text-right m-2">
    <p class="text_p">Try <a (click)="selectTemplate()" trackClick="click_bulk_upload_estamp" class="btn-link clickable link_text"> Bulk Upload </a>if
      you have more than 5 stamp details
  </div>
  <div *ngIf="showEditTemplate" class="text-right">
    <p class="text_p_6">Try <a (click)="selectTemplate()" trackClick="click_bulk_upload_edit_template" class="btn-link clickable link_text_1"> Bulk Upload </a>if
      you have more than 5 stamp details
  </div>
  <!-- Created useable components  so that we can use in estamp , esign and cat-upload Services     -->
  <div *ngIf="showProductDetails">
    <app-product-details [productDetailsData]="productDetailsData"
      (productDetailsChange)="onproductDetailsChange($event)"></app-product-details>
  </div>
  <div *ngIf="showEditTemplate">
    <app-template-edit [editTemplateData]="sendEditTemplateData"
      (editTemplateChange)="oneditTemplateChange($event)"></app-template-edit>
  </div>
  <div *ngIf="showEstampDetails">
    <app-estamp-details [estampData]="estampData" (estampChange)="onestampDataChange($event)"></app-estamp-details>
  </div>
  <div *ngIf="showEsignDetails">
    <app-e-sign-details [esignData]="esignData" [showESignOptions]="true" (esignDataChange)="onesignDataChange($event)"></app-e-sign-details>
  </div>
  <div *ngIf="showConfirmation">
    <app-order-confirmation-details #orderDetails [orderConfirmationData]="orderConfirmationData"
      (orderConfirmationChange)="onOrderConfirmationChange($event)"></app-order-confirmation-details>
  </div>

</div>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>


<p-confirmDialog [style]="{width: '50vw'}" (onAccept)="onApproveMethod()"></p-confirmDialog>


<ng-template #reviewOrder let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-review-order-details [reviewOrderData]="reviewOrderData"
        (reviewOrderDataChange)="reviewOrderDataChange($event)"></app-review-order-details>
    </div>
  </div>
</ng-template>


<ng-template #paymentScreen let-modal>

  <div class="modal-header">
    <strong *ngIf="paymentDetails.paymentMethod!=='wallet'">Payment Details</strong>
    <strong *ngIf="paymentDetails.paymentMethod==='wallet'">Payment Details (Wallet)</strong>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
    <app-payment-order [paymentOrderData]="paymentOrderData"
    (paymentOrderDataChange)="paymentOrderDataChange($event)"></app-payment-order>
    </div>
  </div>
</ng-template>